import { ChangeEventHandler, useCallback, useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";

import { uploadFile } from "~/api/media/upload";
import { useLanguage } from "~/contexts/providers/language";
import englishTranslations from "~/localization/en";
import frenchTranslations from "~/localization/fr";
import { CreateMemberInput } from "~/types/user/user.types";

import ApplicationInput from "../../input";
import ApplicationRulesOfSilencio from "../../ruleOfSilencio";
import styles from "./index.module.scss";

const ApplicationProfilePicture = () => {
  const {
    setValue,
    resetField,
    clearErrors,
    formState: { errors },
  } = useFormContext<CreateMemberInput>();
  const [imageUrl, setImageUrl] = useState("");

  const { language } = useLanguage();
  const applyTexts =
    language === "En"
      ? englishTranslations.applyPage
      : frenchTranslations.applyPage;

  const handleSetImageUrl = useCallback(
    async (files: FileList) => {
      console.log("here upload");
      try {
        const key = await uploadFile({
          file: files[0],
          isPublic: true,
          path: "profile/pictures",
        });
        setImageUrl(URL.createObjectURL(files[0]));
        clearErrors("profilePicturePath");
        setValue("profilePicturePath", key);
      } catch (error) {
        console.error(error);
        resetField("profilePicturePath");
      }
    },
    [setImageUrl, setValue]
  );

  const handleUploadImage: ChangeEventHandler<HTMLInputElement> = (e) => {
    if (!e.target.files) return;
    handleSetImageUrl(e.target.files);
  };

  const handlePasteImage = useCallback(
    (e: ClipboardEvent) => {
      const data = e.clipboardData;
      if (data) {
        handleSetImageUrl(e.clipboardData.files);
      }
    },
    [handleSetImageUrl]
  );

  useEffect(() => {
    document.addEventListener("paste", handlePasteImage);
    return () => {
      document.removeEventListener("paste", handlePasteImage);
    };
  }, [handlePasteImage]);

  const errorMessage = errors.profilePicturePath?.message;

  return (
    <>
      <p>{applyTexts.applicationForm.uploadPhotoText}</p>
      <p>
        {applyTexts.applicationForm.uploadPhotoPolicy}
        <ApplicationRulesOfSilencio
          text={` → ${applyTexts.applicationForm.privacyPolicy}`}
        />
      </p>

      <div className={styles.applicationPictureInputContainer}>
        {imageUrl ? (
          <>
            <picture className={styles.picture}>
              <span
                className={styles.cancel}
                onClick={() => {
                  setImageUrl("");
                  resetField("profilePicturePath");
                }}
              >
                X
              </span>
              <img src={imageUrl} alt="profile picture" />
            </picture>
          </>
        ) : (
          <>
            <ApplicationInput
              register="profilePicturePath"
              label="card number"
              type="file"
              fileAccept={["image/png", "image/jpeg", "image/jpg"]}
              handleFileUpload={handleUploadImage}
              value={imageUrl}
            />
          </>
        )}
      </div>
      {errorMessage && <p>{errorMessage}</p>}
      <p>{applyTexts.applicationForm.imageDescription}</p>
    </>
  );
};

export default ApplicationProfilePicture;
